import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatSelectModule } from '@angular/material/select';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { Subject, switchMap } from 'rxjs';
import { IstanzeService } from 'app/services/istanze.service';
import { MatExpansionModule} from '@angular/material/expansion';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { IstanzaBaseComponent } from 'app/modules/istanza-base/istanzabase.component';
import { PagopaService } from 'app/services/pagopa.service';


@Component({
    templateUrl: './allsteps.type.html',
    styleUrls: ['./allsteps.type.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        MatButtonModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        MatOptionModule,
        FormlyModule,
        MatSelectModule,
        MatInputModule,
        MatSidenavModule,
        RouterLink,
        MatIconModule,
        MatProgressBarModule,
        MatTabsModule,
        MatExpansionModule
    ],
    encapsulation: ViewEncapsulation.None,
     changeDetection: ChangeDetectionStrategy.OnPush
    })
export class FormlyFieldAllSteps extends FieldType implements OnInit {

    constructor(
        private _istanzeService: IstanzeService,
        private _pagopaService: PagopaService,
        private _change: ChangeDetectorRef

    ) {
        super()
    }


    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _userService = inject(UserService)


    pagamentiTotali: number = 0;

    showPagamenti: boolean = false;

    baseStep: FormlyFieldConfig

    steps: FormlyFieldConfig[]
    user: User
    IstanzaBaseComponent: IstanzaBaseComponent;

    readonly panelOpenState = signal(false);

    /*
    disableFields(fields:FormlyFieldConfig): void {
        fields.fieldGroup.forEach((f)=>{
            if (f.key){
                if (f.key!='riepilogo_ok'){
                    f.props.disabled = true;
                }
            }
            else if (f.fieldGroup) {
                this.disableFields(f)
            }
        })
    }*/

    ngOnInit(): void {

        this._userService.user$.subscribe(user=>this.user=user)
        //il promo filedgroup in sezione dedicata
        this.baseStep = this.field.fieldGroup[0];
        //gli altri a scomparsa
        this.steps = this.field.fieldGroup.slice(1);
        this.IstanzaBaseComponent = this.options.formState.cmp;

    }


    tornaCompilazione(): void {

        this._istanzeService.tornaCompilazione().pipe(
            switchMap((istanza)=>this._pagopaService.delPagamentiIstanza(istanza))
        ).subscribe(
            (istanza)=>{
                //this._changeDetectorRef.markForCheck();
                let top = document.getElementById('topStepper');
                if (top !== null) {
                    top.scrollIntoView();
                    top = null;
                }
            }

        )

    }

    inoltraIstanza(): void {
        this._istanzeService.inoltraIstanza().subscribe(
            ()=>location.reload()
        )
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    trackByFn(index: number, item: any): any {
        return item.id || index;
    }



}
